import axios from 'axios';
import { upperCase } from 'lodash';

export async function initBucky(experiment) {

    try {
        if (isDebug()) {

            // for testing purposes
            return {
                variant: 'show_cards',
                session: Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)
            };
        }

        const response = await axios.post(`${getBuckyUrl()}/tracking/session`, {
            'experiment': experiment
        });

        const responseData = response.data.data;
        const variantKey = responseData.variant.key;
        const sessionId = responseData.id;

        return {
            variant: variantKey,
            session: sessionId
        };

    }
    catch (error) {
        return {
            error: true,
            message: 'Failed to initialize Bucky',
            variant: null,
            session: null
        };
    }
}

export async function conversion(session) {

    if (isDebug()) {
        console.log('Bucky conversion', session);
        return;
    }

    try {
        await axios.post(`${getBuckyUrl()}/tracking/conversion`, {
            'session': session
        });
    }
    catch (error) {}
}

function isDebug() {
    return upperCase(process.env.APP_DEBUG) === 'TRUE';
}

function getBuckyUrl() {
    return process.env.BUCKY_API_BASE_URL;
}